import signInJson from '../../../assets/translations/sign-in.json'

export const languageContent: any = signInJson
